import styled from 'styled-components'
import check from '../../../../../assets/certificates/AddParameter/Modal/check.svg'
import cross from '../../../../../assets/certificates/AddParameter/Modal/switch-cross.svg'
import crosslight from '../../../../../assets/stock/FiltersHeader/cross.svg'
import vector from '../../../../../assets/equipment/vector.svg'
import vectorlight from '../../../../../assets/equipment/vectorlight.svg'

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
`

export const SubHeaderContainer = styled.div`
  background-color: #fff;
  margin-bottom: 1.5rem;
  padding: 1.3rem 4.1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 0.8rem;
  flex-shrink: 0;
`

export const MainContainer = styled.div`
  background-color: #f4f4f4;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-bottom: 2rem;
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  ::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 10px;
    border: 2px solid #c0c0c0;
  }
`

export const SectionName = styled.h2`
  font-size: 1.4rem;
  font-weight: 700;
  width: fit-content;
`

export const LeftSide = styled.div`
  display: flex;
  align-items: center;
`

export const BreadcrumbsContainer = styled.nav`
  font-size: 14px;
  margin-bottom: 1.5rem;
  flex-shrink: 0;
  ol {
    list-style: none;
    padding: 0;
    padding-inline-start: 0;
    margin: 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  li {
    display: flex;
    align-items: center;
    color: var(--light-text-color, #666);
    &:not(:last-child)::after {
      content: '>';
      margin: 0 8px;
      color: var(--input-border, #999);
    }
    a {
      text-decoration: none;
      color: #0090d3;
      white-space: nowrap;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
    &:last-child {
      span {
        color: var(--text-color, #333);
        white-space: nowrap;
        cursor: default;
      }
      a {
        color: var(--text-color, #333);
        cursor: default;
        text-decoration: none;
      }
    }
  }
`

export const StyledCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 15px;
  position: relative;
`

export const CardTitle = styled.h2<{ isMaintenance?: boolean }>`
  font-size: 20px;
  font-weight: 700;
  ${(props) =>
    !props.isMaintenance &&
    `
    padding-bottom: 20px;
  `}
`

export const StyledCard = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 25px 20px;
  margin-bottom: 20px;
`

export const FormGrid = styled.div<{ cols: number }>`
  display: grid;
  grid-template-columns: repeat(${(props) => props.cols}, 1fr);
  gap: 20px 30px;
  @media (max-width: 992px) {
    grid-template-columns: ${(props) =>
      props.cols === 3 ? 'repeat(2, 1fr)' : 'repeat(2, 1fr)'};
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const StyledFormGroup = styled.div`
  display: flex;
  flex-direction: column;

  label {
    font-size: 14px;
    color: var(--light-text-color);
    margin-bottom: 8px;
    font-weight: bold;
    position: static;
    top: auto;
    left: auto;
    background-color: transparent;
    padding: 0;
    z-index: auto;
  }

  input,
  select {
    padding: 8px 15px;
    border: 1px solid var(--input-border);
    border-radius: 100px;
    font-size: 14px;
    outline: none;
    width: 100%;
    box-sizing: border-box;
    height: 40px;
    line-height: 22px;

    background-color: #ebebeb;
    color: #333;

    &:disabled,
    &[readonly] {
      background-color: #c4c4c4;
      color: #696969;
      cursor: not-allowed;
      border-color: #dfdfdf;
    }
  }

  select {
    background-image: url(${vector});
    background-size: 18px 9px;
    background-repeat: no-repeat;
    background-position: right 15px center;
    padding-right: 2.5rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    color: #333;
    option[value=''] {
      color: #c4c4c4;
    }
    option {
      color: #333;
      background-color: white;
    }

    &:disabled,
    &[readonly] {
      background-image: url(${vectorlight});
      background-size: 32px 16px;
      background-repeat: no-repeat;
    }

    &[multiple] {
      border-radius: 8px;
      height: auto;
      padding: 12px;
      background-image: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      min-height: 100px;
      overflow-y: auto;
    }
  }

  &.flex-grow {
    flex-grow: 1;
  }
`

const StyledFormGroupWithBorder = styled(StyledFormGroup)`
  padding: 20px 15px;
  background-color: #fff;
  border-radius: 8px;
  input,
  select {
    border: none;
    margin-top: 0;
  }
`

export const MaintenanceServiceWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 5rem;
  flex-wrap: wrap;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
`

export const ToggleSwitchContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  font-weight: 500;
  color: var(--light-text-color);
  position: relative;
`

export const ToggleSwitchLabelText = styled.span`
  font-size: 14px;
  color: var(--light-text-color);
  font-weight: bold;
  position: absolute;
  left: 0;
`

export const SwitchLabel = styled.label`
  position: relative;
  display: inline-block;
  width: 48px;
  height: 34px;
  margin-top: 28px;

  &.verification-switch-align {
    margin-top: -8.5px;
  }
`

export const SwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  :checked + .slider {
    border: 0;
    padding: 2px;
  }

  :checked + .slider:before {
    background-image: url(${check});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 15px 15px;
    background-color: #fff;
    -webkit-transform: translateX(13px);
    -ms-transform: translateX(13px);
    transform: translateX(13px);
  }
`

export const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;
  border: #696969 2px solid;

  ${SwitchInput}:checked + & {
    background-color: #0090d3;
    border-color: #0090d3;
  }

  :before {
    display: block;
    position: relative;
    content: '';
    height: 24px;
    width: 24px;
    left: 4px;
    top: 2.8px;
    background-color: #696969;
    border-radius: 50%;
    transition: all 0.4s;
    background-image: url(${cross});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 11px 11px;
  }
`

export const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 15px;
`

export const CancelButton = styled.button`
  background-color: #ffffff;
  color: #0090d3;
  border: 1px solid #0090d3;
  padding: 12px 24px;
  border-radius: 100px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
`

export const SaveButton = styled.button`
  background-color: #0090d3;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 100px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;
`

export const AddMaintenanceButton = styled.button`
  background-color: transparent;
  color: #0090d3;
  border: 1px solid #0090d3;
  padding: 12px 24px;
  border-radius: 100px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;
  img {
    width: 12px;
    height: 12px;
  }
`

export const NameGroup = styled(StyledFormGroupWithBorder)``

export const PeriodicidadeGroup = styled(StyledFormGroupWithBorder)`
  .input-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;

    .prefix-text {
      font-size: 14px;
      color: #333;
      white-space: nowrap;
      flex-shrink: 0;
    }

    input,
    select {
      flex: 1;
      min-width: 60px;
      & + select {
        min-width: 80px;
      }
    }
  }
`

export const VerificationGroup = styled(StyledFormGroupWithBorder)`
  .toggle-content-wrapper {
    display: flex;
    gap: 15px;
    width: 100%;
    align-items: flex-start;

    ${ToggleSwitchContainer} {
      margin-top: 0;
      ${ToggleSwitchLabelText} {
        margin-top: 0;
      }
    }
  }

  .verification-fields {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;

    .prefix-text {
      font-size: 14px;
      color: #333;
      white-space: nowrap;
      flex-shrink: 0;
    }

    input,
    select {
      flex: 1;
      min-width: 60px;
      & + select {
        min-width: 80px;
      }
    }
  }
`

export const DeleteButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  margin-top: 28px;

  img {
    width: 20px;
    height: 20px;
    object-fit: contain;
  }
`

export const StyledMaintenanceItem = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.25fr auto 1.25fr 32px;
  gap: 20px;
  align-items: start;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 15px;

  &:last-child {
    margin-bottom: 0;
  }

  ${NameGroup} {
    grid-column: 1 / 2;
    grid-row: 1;
    padding: 0;
    border: none;
  }

  ${PeriodicidadeGroup} {
    grid-column: 2 / 3;
    grid-row: 1;
    padding: 0;
    border: none;
  }

  img[alt='Separador'] {
    grid-column: 3 / 4;
    grid-row: 1;
    align-self: center;
    height: 100%;
    width: 1px;
    background-color: #e0e0e0;
    justify-self: center;
    margin: 0;
  }

  ${VerificationGroup} {
    grid-column: 4 / 5;
    grid-row: 1;
    padding: 0;
    border: none;
  }

  ${DeleteButton} {
    grid-column: 5 / 6;
    grid-row: 1;
    align-self: flex-start;
    justify-self: end;
  }

  ${MaintenanceServiceWrapper} {
    grid-column: 1 / -1;
    grid-row: 2;
    margin-top: 10px;
    width: 100%;
    display: flex;
    align-items: flex-start;
    gap: 5rem;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  @media (max-width: 1200px) {
    grid-template-columns: 1fr 1fr 50px;
    grid-template-rows: auto auto auto;
    ${NameGroup} {
      grid-column: 1 / 2;
      grid-row: 1;
    }
    ${PeriodicidadeGroup} {
      grid-column: 2 / 3;
      grid-row: 1;
    }
    ${VerificationGroup} {
      grid-column: 1 / 3;
      grid-row: 2;
    }
    img[alt='Separador'] {
      display: none;
    }
    ${DeleteButton} {
      grid-column: 3 / 4;
      grid-row: 1;
    }
    ${MaintenanceServiceWrapper} {
      grid-column: 1 / -1;
      grid-row: 3;
    }
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    gap: 15px;
    padding: 15px;

    ${NameGroup}, ${PeriodicidadeGroup}, ${VerificationGroup}, ${DeleteButton} {
      grid-column: 1 / -1;
      grid-row: auto;
      width: 100%;
      min-width: unset;
    }
    ${DeleteButton} {
      justify-self: flex-start;
    }
    ${MaintenanceServiceWrapper} {
      grid-column: 1 / -1;
      grid-row: auto;
      flex-direction: column;
      align-items: flex-start;
      gap: 15px;
    }
    img[alt='Separador'] {
      display: none;
    }
  }
`

export const DropdownSelectedItemTag = styled.span`
  background-color: #fff;
  color: #333;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #e0e0e0;
  white-space: nowrap;
  font-weight: 400;

  button {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    margin: 0;
    line-height: 1;
    width: 12px;
    height: 12px;
    background-image: url(${crosslight});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    color: transparent;
  }
`

export const DropdownHeaderSelectedItems = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  align-items: center;
  min-height: 18px;
  line-height: normal;
  flex-grow: 1;
  margin-top: 8px;
`

export const DropdownContainer = styled.div`
  position: relative;
  width: 100%;
`

export const DropdownHeader = styled.div`
  padding: 8px 15px;
  border-radius: 100px;
  font-size: 14px;
  background-color: #ebebeb;
  color: #333;
  cursor: pointer;
  display: flex;
  align-items: center;
  user-select: none;
  box-sizing: border-box;
  height: 40px;
  line-height: 22px;
  overflow: hidden;
  position: relative;
  background-image: url(${vector});
  background-size: 18px 9px;
  background-repeat: no-repeat;
  background-position: right 15px center;
  padding-right: 2.5rem;

  &.disabled {
    background-color: #c4c4c4;
    color: #696969;
    cursor: not-allowed;
    background-image: url(${vectorlight});
    background-size: 32px 16px;
    background-repeat: no-repeat;
    background-position: right 8px center;
  }

  .dropdown-placeholder {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 15px;
    color: #c4c4c4;
    pointer-events: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: calc(100% - 30px - 2.5rem);
  }

  .dropdown-selected-text {
    flex-grow: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 10px;
    color: #333;
  }
`

export const DropdownList = styled.ul`
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
  border: 1px solid var(--input-border, #ccc);
  border-radius: 8px;
  background-color: white;
  list-style: none;
  padding: 8px 0;
  margin-bottom: 5px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;

  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`

export const DropdownListItem = styled.li`
  padding: 10px 15px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;

  &:hover {
    background-color: #f0f0f0;
  }

  &.selected {
    background-color: #e0f2f7;
    color: #0090d3;
    font-weight: bold;

    &::before {
      content: '';
      position: absolute;
      left: 10px;
      top: 50%;
      transform: translateY(-50%);
      width: 12px;
      height: 12px;
      background-image: url(${check});
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }
    padding-left: 30px;
  }

  .checkbox-custom {
    display: none;
  }
`